import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  caricamentoInCorso: true,
  messaggi: [],
  padre: null,
  mostraModaleRisposta: false,
  messaggioDaInviare: '',
};

const conversazioniSlice = createSlice({
  name: 'conversazioni',
  initialState,
  reducers: {
    caricamento(state, action) {
      state.caricamentoInCorso = Boolean(action.payload);
    },
    aggiornaMessaggi(state, action) {
      state.messaggi = action.payload;
    },
    aggiornaPadre(state, action) {
      state.padre = action.payload;
    },
    apriModaleRisposta(state) {
      state.mostraModaleRisposta = true;
    },
    chiudiModaleRisposta(state) {
      state.messaggioDaInviare = '';
      state.mostraModaleRisposta = false;
    },
    resetStato(state) {
      state = initialState;
    },
    setMessaggioDaInviare(state, action) {
      state.messaggioDaInviare = action.payload;
    },
  },
});

export const { caricamento, aggiornaMessaggi, aggiornaPadre, resetStato, apriModaleRisposta, chiudiModaleRisposta, setMessaggioDaInviare } =
  conversazioniSlice.actions;
const conversazioniReducer = conversazioniSlice.reducer;

export default conversazioniReducer;
